import { MapPin, ArrowUpRight, Instagram } from "lucide-react";
import { useLanguage, CONTACTS } from "../i18n";
import { SHOW_PHOTOS } from "../data";
import { Reveal, Eyebrow } from "./Reveal";
import { INSTAGRAM_GRID } from "../data";

export const Location = () => {
  const { t } = useLanguage();
  return (
    <>
      <section
        id="contatti"
        data-testid="location-section"
        className="relative py-24 sm:py-36"
        style={{ backgroundColor: "#F5EFE6" }}
      >
        <div className="max-w-7xl mx-auto px-6 sm:px-10">
          <div className="max-w-2xl">
            <Reveal>
              <Eyebrow>{t.location.eyebrow}</Eyebrow>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="mt-4 font-display font-light text-3xl sm:text-4xl lg:text-[2.75rem] tracking-tight text-[#2C0F1A]">
                {t.location.title}
              </h2>
            </Reveal>
            <Reveal delay={0.18}>
              <p className="mt-6 text-base leading-relaxed text-[#5A4440] max-w-lg">
                {t.location.desc}
              </p>
            </Reveal>
            <Reveal delay={0.26}>
              <div className="mt-9 space-y-4 text-sm text-[#5A4440]">
                <p className="flex items-start gap-3">
                  <MapPin size={16} strokeWidth={1.5} className="mt-0.5 text-[#A5713C] shrink-0" />
                  <span data-testid="location-address">{CONTACTS.address}</span>
                </p>
                <p className="font-meta text-[10px] uppercase tracking-[0.22em] text-[#A5713C]">
                  {t.location.parking}
                </p>
              </div>
            </Reveal>
            <Reveal delay={0.32}>
              <div className="mt-9 flex flex-col sm:flex-row gap-4">
                <a
                  data-testid="google-maps-directions-link"
                  href={CONTACTS.mapsUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full bg-[#480A1A] text-[#F5EFE6] font-meta text-[11px] uppercase tracking-[0.22em] hover:bg-[#2C0F1A] transition-colors duration-300"
                >
                  {t.location.directions}
                  <ArrowUpRight size={15} />
                </a>
                <a
                  data-testid="location-email-link"
                  href={`mailto:${CONTACTS.email}`}
                  className="inline-flex items-center justify-center px-8 py-4 rounded-full border border-[#480A1A]/30 text-[#480A1A] font-meta text-[11px] uppercase tracking-[0.22em] hover:border-[#480A1A] transition-colors duration-300"
                >
                  {CONTACTS.email}
                </a>
              </div>
            </Reveal>
          </div>
        </div>
      </section>

      <section
        data-testid="instagram-feed-section"
        className="py-20 sm:py-28"
        style={{ backgroundColor: "#FDFBF7" }}
      >
        <div className="max-w-7xl mx-auto px-6 sm:px-10">
          <div className="flex flex-wrap items-end justify-between gap-5">
            <div>
              <Reveal>
                <Eyebrow>{t.instagram.eyebrow}</Eyebrow>
              </Reveal>
              <Reveal delay={0.1}>
                <a
                  data-testid="instagram-profile-link"
                  href={CONTACTS.instagramUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-3 inline-flex items-center gap-3 font-display font-light text-2xl sm:text-3xl text-[#2C0F1A] hover:text-[#A5713C] transition-colors duration-300"
                >
                  <Instagram size={22} strokeWidth={1.5} className="text-[#A5713C]" />
                  {t.instagram.title}
                </a>
              </Reveal>
            </div>
          </div>
          {SHOW_PHOTOS && (
          <div className="mt-10 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3">
            {INSTAGRAM_GRID.map((src, i) => (
              <Reveal key={i} delay={i * 0.05}>
                <a
                  data-testid={`instagram-tile-${i}`}
                  href={CONTACTS.instagramUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group block overflow-hidden aspect-square"
                >
                  <img
                    src={src}
                    alt={`Sant'Irene Instagram ${i + 1}`}
                    loading="lazy"
                    className="w-full h-full object-cover transition-transform duration-[1200ms] ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:scale-[1.06]"
                  />
                </a>
              </Reveal>
            ))}
          </div>
          )}
        </div>
      </section>
    </>
  );
};
